export const collegiateApiUrl = 'https://collegebowlingseasonapi-dev.azurewebsites.net';
export const searchServiceUrl = 'https://devwebservices.bowl.com/USBC.Search.Services';
export const ssoUrl = "https://devsignon.bowl.com";
export const siteUrl = "https://devcollegebowlingtournament.bowl.com";
export const clientId = "COLLEGIATERANKING_CLIENT_9208B74D-C5FD-47B9-8C68-6E5CA3B9E903";
export const apiScope = "COLLEGIATERANKING_APIKEY_06AB4276-3C7F-443E-BF99-9A2E73C531BD Catapult.CollegiateApi Usbc.Web.Profile";
export const ssoProfileUrl = "https://devsignon.bowl.com/Manage?clientId=COLLEGIATERANKING_CLIENT_9208B74D-C5FD-47B9-8C68-6E5CA3B9E903";


// WEBPACK FOOTER //
// ./src/config/constants.Development.js